import React, { FunctionComponent } from 'react';

import styles from './PostCardMedia.module.scss';
import { BluePlayArrowIcon, SmallAlbumIcon } from 'app/assets/images/icons';
import DefaultVideo from '../../assets/images/defaultVideo.png';
import { Grid } from '@material-ui/core';
import { useModal } from 'app/context/Modal';

interface Props {
  data: any;
}

const PostCardMedia: FunctionComponent<Props> = ({ data }) => {
  const modal = useModal();
  const handelOpenImageVideo = (index = 0) => {
    modal.show({
      imageUrls: data?.attachments,
      imageIndex: index,
    });
  };
  const RenderInstagramAlbumOrImage = () => {
    if (
      (data?.icon === 'Instagram' && data?.post_type === 'ALBUM') ||
      (data?.icon === 'Instagram' && data?.post_type === 'IMAGE')
    ) {
      return (
        <Grid className={styles.albumContainer}>
          {data?.post_type === 'ALBUM' && (
            <span
              onClick={() => {
                handelOpenImageVideo(0);
              }}
            >
              <SmallAlbumIcon />
            </span>
          )}
          {data?.attachments?.[0]?.type === 'IMAGE' ? (
            <img
              src={data?.attachments?.[0]?.url}
              alt="image"
              key={data?.attachments?.[0]?.url}
              onClick={() => {
                handelOpenImageVideo(0);
              }}
            />
          ) : (
            <RenderVideosReel />
          )}
        </Grid>
      );
    }
    return <></>;
  };
  const RenderVideosReel = () => (
    <a
      target="_blank"
      rel="noreferrer"
      onClick={() => handelOpenImageVideo(0)}
      className={`${styles.ImageUrl} ${styles.fullWidth}${styles.videoMargin}`}
    >
      <img
        src={
          data?.attachments?.[0].thumbnail
            ? data?.attachments?.[0].thumbnail
            : DefaultVideo
        }
        alt=" image alt"
      />
      {data?.attachments?.[0]?.thumbnail?.length !== 0 && (
        <a
          target="_blank"
          rel="noreferrer"
          onClick={() => handelOpenImageVideo(0)}
          className={styles.VideoBtn}
        >
          <BluePlayArrowIcon />
        </a>
      )}
    </a>
  );
  const RenderInstagramVideos = () => {
    if (
      (data?.icon === 'Instagram' && data?.post_type === 'VIDEO') ||
      (data?.icon === 'Instagram' && data?.post_type === 'REEL') ||
      (data?.icon === 'Instagram' && data?.post_type === 'IGTV')
    ) {
      return <RenderVideosReel />;
    }
    return <></>;
  };

  return (
    <div className={styles.PostCardMedia}>
      <RenderInstagramAlbumOrImage />
      <RenderInstagramVideos />
    </div>
  );
};

export default PostCardMedia;
